import app from "js/legacy-app";

app.directive('plActions', [function () {
    return {
        template: '<div class="pageable-list__actions" data-ng-transclude></div>',
        replace: true,
        transclude: true
    };
}]);